import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/LoginPage'
import RequestPage from '@/components/RequestsPage'
import store from '../store'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/requests',
      name: 'RequestPage',
      component: RequestPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/requests', '/']
  console.log(to.path)
  const authRequired = publicPages.includes(to.path)
  var isLogin = store.state.isLogin
  if (isLogin === false) {
    if (authRequired) {
      console.log('push to login')
      return next('login')
    }
  }
  if (to.path === '/') {
    return next('requests')
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js